/* eslint-disable */
class BlocksToHtml {
    constructor(data) {
        this.data = data;
    }

    generate(oldData = false) {        
        let html='';
        // console.log('This Data', this.data)
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].type === 'header') {
                html += '<p></p>'
                html += `<h${this.data[i].data.level}>${unescape(this.data[i].data.text)}</h${this.data[i].data.level}>`
            }
            
            if (this.data[i].type === 'title') {
                html += '<p></p>'
                html += `<p>${this.data[i].data.text}</p>`
            }

            if (this.data[i].type === 'paragraph') {
                if (oldData) {
                    html += '<p></p>'
                }
                html += `<p>${this.data[i].data.text}</p>`
            }

            if (this.data[i].type === 'list') {
                // html += '<p></p>'
                if (this.data[i].data.style === 'unordered') 
                {
                    html += '<ul>'
                    for(let j=0; j < this.data[i].data.items.length; j++) {
                        html += `<li>${this.data[i].data.items[j]}</li>`
                    }
                    html += '</ul>'
                } else {
                    html += '<ol>'
                    for(let j=0; j < this.data[i].data.items.length; j++) {
                        html += `<li>${this.data[i].data.items[j]}</li>`
                    }
                    html += '</ol>'
                }
               
            }

            if (this.data[i].type === 'image') {                
                html += `<img style="margin-bottom:15px;" width="350" src="${this.data[i].data.url}">`
            }
            
            if (this.data[i].type === 'delimiter') {
                html += '<p></p>'
                html += '<hr/>'
            }
        }
        return html
    }
}

export default BlocksToHtml


// WEBPACK FOOTER //
// ./src/components/editor/generator/blocksToHtml.js